import * as React from "react";

import { Map, InfoWindow, Marker, GoogleApiWrapper, MarkerProps, MapProps } from "google-maps-react";
import LoadingWidget from "./LoadingWidget";

interface Props {
    google: any;
    mapCentre: Coordinates;
    markerLocation: Coordinates;
    disabled: boolean;
    onMarkerLocationChange?: (latitude: number, longitude: number) => void;
}

interface State {}

type Coordinates = { lat: number; lng: number };

export class MapContainer extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    handleMarkerLocation = (coord: any) => {
        const { latLng } = coord;
        const latitude = latLng.lat();
        const longitude = latLng.lng();
        this.props.onMarkerLocationChange!(latitude, longitude);
    };

    render() {
        const style = {
            width: "100%",
            height: "300px"
        };

        return (
            <Map
                key={`${this.props.mapCentre.lat}${this.props.mapCentre.lng}`}
                google={this.props.google}
                initialCenter={this.props.mapCentre}
                center={this.props.mapCentre}
                centerAroundCurrentLocation={false}
                zoom={10}
                setMyLocationEnable={false}
            >
                {/* Pass Horse for sale and Map Center Loop Makers with draggable disabled */}
                <Marker
                    key={`marker-${this.props.disabled}`}
                    position={this.props.markerLocation}
                    draggable={!this.props.disabled}
                    onDragend={(markerProps?: MarkerProps, map?: google.maps.Marker, event?: any) =>
                     event && this.handleMarkerLocation(event)
                 }
                />
            </Map>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: `${process.env.REACT_APP_GOOGLE_MAPS_KEY}`
    // LoadingContainer: <LoadingWidget/>
})(MapContainer);



// WEBPACK FOOTER //
// ./src/components/common/GoogleMaps.tsx